module.exports = __webpack_public_path__ + "static/img/logo.3081d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 667
// module chunks = 1